import { render, staticRenderFns } from "./IconElement.vue?vue&type=template&id=7424a5a3&"
import script from "./IconElement.vue?vue&type=script&lang=js&"
export * from "./IconElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports